





















































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AbpBase from '../../../lib/abpbase'
import VipApi from '@/api/vip/list'
import OrderApi from '@/api/order/list'
import VipTag from '@/api/vip/vipTag/index'
import TagSelect from '@/components/tag-select/index.vue'
import ShopApi from '@/api/shopInfo/index'
@Component({
  components: {
    TagSelect,
  },
})
export default class StoreDetail extends AbpBase {
  status: boolean = false
  columns: any[] = [
    {
      title: '头像',
      slot: 'headImgUri',
      align: 'center',
    },
    {
      title: '姓名',
      key: 'nickName',
      align: 'center',
    },
    {
      title: '性别',
      key: 'gender',
      align: 'center',
    },
    {
      title: '工号',
      key: 'vipCode',
      align: 'center',
    },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
    },
    {
      title: '所属门店',
      key: 'storeName',
      align: 'center',
    },
    {
      title: '出生日期',
      slot: 'birthDay',
      align: 'center',
    },
    // {
    //   title: '操作',
    //   slot: 'action',
    //   align: 'center',
    // },
  ]
  tableData: any[] = []
  table: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 999,
  }

  recentType = null

  vipInfos: any = {}
  allTagList: any[] = []
  showTag: boolean = false
  selectedItems: any = []

  get tagList() {
    return this.vipInfos.tags
  }

  created() {
    // this.getVipInfos()
    this.getVipList()
    this.getStoreinfo()
  }
  // 获取门店详情
  getStoreinfo() {
    let id = this.$route.query['id']
    if (id) {
      ShopApi.getShopInfo(id.toString()).then((res) => {
        console.log('门店详情', res)
        this.vipInfos = res.data
      })
    }
  }

  /**
   * 获取会员明细
   */
  getVipList() {
    let id = this.$route.query['id']
    if (id) {
      let { table } = this
      VipApi.getNewVipList(999, 0, '', id.toString()).then((res) => {
        if (res.data) {
          this.tableData = res.data.items
          table.totalCount = res.data.totalCount
        }
      })
    }
  }

  orderTypeString(type) {
    let text = type
    switch (type) {
      case 0:
        text = '常规订单'
        break
      case 1:
        text = '拼团订单'
        break
      case 2:
        text = '积分订单'
        break
    }

    return text
  }

  /**
   * 查看订单详情
   */
  orderDetailFn(row) {
    this.$router.push({
      name: 'orderDetail',
      query: {
        id: row.id,
      },
    })
  }

  /**
   * 更改页数
   */
  changePage(e, which, click?) {
    switch (which) {
      case 1:
        this.table.currentPage = e
        break
      default:
        this['table' + which].currentPage = e
        break
    }
    if (this[click]) {
      this[click]()
    }
  }
}
